import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function HotSection() {
  const hot = [...comics].sort((a, b) => b.hot - a.hot).slice(0, 6);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <p className="flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
            <span className="inline-block h-2 w-2 rounded-full bg-primary-500"></span>热门连载
          </p>
          <h2 className="font-heading mt-3 text-2xl text-foreground-950 md:text-4xl">
            大家都在追的连载
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
            按人气热度精选的热门连载，抢先看最新话、同步更新进度与汉化进度实时同步。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {hot.map((c) => (
            <ComicCard key={c.id} comic={c} />
          ))}
        </div>
      </div>
    </section>
  );
}